import classNames from 'classnames';
import { OptionCardProps } from 'LearningManager/constants/createAssignment.constant';
import { FC } from 'react';
import styles from './OptionCard.module.scss';

const OptionCard: FC<OptionCardProps & { htmlId?: string }> = ({
	selectedId,
	toggleSelect,
	id,
	htmlId,
	icon,
	desc,
	title
}) => {
	const isSelected = selectedId === id;

	return (
		<div
			id={htmlId}
			className={classNames(styles.card, {
				[styles['card--selected']]: isSelected
			})}
			onClick={() => toggleSelect(id)}
		>
			<div className={styles.label}>
				{icon}
				<div className={styles.head}>{title}</div>
			</div>
			<div className={styles.value}>{desc}</div>
		</div>
	);
};

export default OptionCard;
